export default {
  mounted() {
    this.el.focus()
    this.el.select()
  }
}
